import { Box, Grid2, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InviteFriendsIcon from "assets/images/inviteOn.png";
import Avatar from "assets/images/avatar.png";
import UserIcon from "assets/images/userIconOn.png";
import LockIcon from "assets/images/lockOff.png";
import CardIcon from "assets/images/onCardOn.png";
import Privileges from "assets/images/privilegesOff.png";
import LogoutIcon from "assets/images/logoutIcon.png";
import FooterLogo from "assets/images/footer-logo.png";
import CallSupportIcon from "assets/images/callSupport.png";
import OpenIcon from "assets/images/openIcon.png";
import OpenIconActive from "assets/images/openIconActive.png";
import navigationEnum from "lib/enums/navigationEnum";
import useInfoContext from "hooks/useInfoContext";
import TlIcon from "assets/images/tlIcon.png";
import CircularProgressComponents from "../../components/CircularProgress";
import "./index.scss";
import { useTheme } from "@emotion/react";
import InfoGif from "assets/gif/infoGif.json";
import Lottie from "lottie-react";
import CustomModalLogOut from "components/modalLogout";
import PaymentModal from "components/modalConcertPayment";
import RegistrationFinishedModal from "components/modalRegistrationFinished";
import { getRepTokenCookie } from "lib/Storage";

const MenuItem = ({ icon, label, isActive, onClick }) => (
  <Box
    className={`menu-item ${isActive ? "active" : ""}`}
    onClick={isActive ? onClick : undefined}
  >
    <img
      src={isActive ? OpenIconActive : OpenIcon}
      alt=""
      className="arrow-icon"
    />
    <Box className="item-content">
      <Box className="item-title">{label}</Box>
      <img src={icon} alt={label} className="item-icon" />
    </Box>
  </Box>
);

const MenuSection = ({ items, className, onItemClick }) => {
  const theme = useTheme();
  return (
    <Box className={className}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <MenuItem
            icon={item.icon}
            label={item.label}
            isActive={item.isActive}
            onClick={() => onItemClick(item)}
          />
          {index < items.length - 1 && (
            <hr
              size={1}
              color={theme.palette.defultText.main}
              className="divider"
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

const CircularProgressItem = ({
  value,
  displayValue,
  unit,
  label,
  maxValue,
}) => {
  if (!maxValue) {
    if (unit === "روز") {
      maxValue = 7;
    } else if (unit === "هفته") {
      maxValue = 4;
    } else if (unit === "ماه") {
      maxValue = 12;
    } else {
      maxValue = 10;
    }
  }

  return (
    <Grid2
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <Grid2 item="true" className="top-text-slider">
        {label}
      </Grid2>
      <Grid2 item="true">
        <CircularProgressComponents
          currentValue={parseInt(displayValue)}
          superValue={parseInt(displayValue) < displayValue ? "بیشتر از" : " "}
          subValue={unit}
          start={0}
          end={maxValue}
        />
      </Grid2>
    </Grid2>
  );
};

const RightSidebar = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");
  const { userInfo, setShowSidebar, itemEvent } = useInfoContext();
  const [difference, setDifference] = useState(null);
  const [openModalLogout, setOpenModalLogout] = useState(false);
  const [openPrice, setOpenPrice] = useState(false);

  const pricePopupCloseHandler = ()=>{
    if(!!getRepTokenCookie())
      navigate("/register-concert");
    else  
      navigate("/accpecting-rules");
    setShowSidebar(false);
  }
  const handleAuthentication = () => {
    setShowSidebar(false);
    navigate("/national-id");
  };

  const handleMenuItemClick = (item) => {
    if (item.path === "/login") {
      setOpenModalLogout(true);
    } else if (item.path.startsWith("http") || item.path.startsWith("tel")) {
      window.location.href = item.path;
    } else {
      navigate(item.path);
      setShowSidebar(false);
    }
  };

  const userMenuItems = [
    {
      icon: UserIcon,
      label: navigationEnum.ACCOUNT.name,
      isActive: true,
      path: navigationEnum.ACCOUNT.path,
    },
    {
      icon: LockIcon,
      label: navigationEnum.SECURITY.name,
      isActive: false,
      path: navigationEnum.SECURITY.path,
    },
    {
      icon: CardIcon,
      label: navigationEnum.ON_CARD.name,
      isActive: true,
      path: navigationEnum.ON_CARD.path,
    },
    {
      icon: Privileges,
      label: navigationEnum.PRIVILEGES.name,
      isActive: false,
      path: navigationEnum.PRIVILEGES.path,
    },
    {
      icon: InviteFriendsIcon,
      label: navigationEnum.INVITE_FRIENDS.name,
      isActive: true,
      path: navigationEnum.INVITE_FRIENDS.path,
    },
    {
      icon: TlIcon,
      label: navigationEnum.TL_TIMELINE.name,
      isActive: true,
      path: navigationEnum.TL_TIMELINE.path,
    },
    {
      icon: CallSupportIcon,
      label: navigationEnum.CALL_SUPPORT.name,
      isActive: true,
      path: navigationEnum.CALL_SUPPORT.path,
    },
    {
      icon: UserIcon,
      label: navigationEnum.REGISTERGUIDE.name,
      isActive: true,
      path: navigationEnum.REGISTERGUIDE.path,
    },

    ...(isMobile
      ? []
      : [
          {
            icon: LogoutIcon,
            label: navigationEnum.LOGOUT.name,
            isActive: true,
            path: navigationEnum.LOGOUT.path,
          },
        ]),
  ];

  useEffect(() => {
    const todayDate = new Date();
    const subDate = new Date(userInfo?.subDate);
    const diffInTime = todayDate - subDate;

    const differenceInYears = todayDate.getFullYear() - subDate.getFullYear();
    const differenceInMonths =
      differenceInYears * 12 + (todayDate.getMonth() - subDate.getMonth());
    const differenceInWeeks = Math.floor(
      diffInTime / (1000 * 60 * 60 * 24 * 7)
    );
    const differenceInDays = Math.floor(diffInTime / (1000 * 60 * 60 * 24));

    setDifference({
      days: differenceInDays,
      weeks: differenceInWeeks,
      months: differenceInMonths,
      years: differenceInYears,
    });
  }, [userInfo]);

  const getDisplayValueAndUnit = (difference) => {
    if (difference?.days < 7) {
      return { displayValue: difference?.days, unit: "روز" };
    } else if (difference?.weeks < 4) {
      return { displayValue: difference?.days / 7, unit: "هفته" };
    } else if (difference?.months < 12) {
      return { displayValue: difference?.days / 30, unit: "ماه" };
    } else {
      return { displayValue: difference?.days / 365, unit: "سال" };
    }
  };

  const { displayValue, unit } = difference
    ? getDisplayValueAndUnit(difference)
    : { displayValue: 0, unit: "روز" };

  const handleClickBanner = () => {
    
    setOpenPrice(true);
    // navigate("/accpecting-rules");
  };
  return (
    <Box className="right-sidebar-component-wrapper">
      <Box className="top-bar">
        <Box className="user-box">
          <Box className="avatar">
            <img src={Avatar} alt="User Avatar" />
          </Box>
          <Box className="user-name">{userInfo?.cardName}</Box>
        </Box>
        <Box className="frequency">{userInfo?.frequency}</Box>
      </Box>
      <Grid2 container spacing={2} className="slider-wrapper">
        <Grid2 size={{ xs: 4 }} item="true">
          <CircularProgressItem
            label="مدت همراهی"
            displayValue={displayValue}
            unit={unit}
          />
        </Grid2>
        <Grid2 size={{ xs: 4 }} item="true">
          <CircularProgressItem
            label="امتیاز"
            displayValue={parseInt(userInfo?.score || 1)}
            maxValue={10000}
            unit={((userInfo?.score || 1) % 1).toFixed(3) * 1000}
          />
        </Grid2>
        <Grid2 size={{ xs: 4 }} item="true">
          <CircularProgressItem
            label="دعوت"
            displayValue={userInfo?.invitedCount || 0}
            maxValue={30}
          />
        </Grid2>
      </Grid2>

      {isMobile &&  (
        <Box sx={{ margin: "15px" }} onClick={handleClickBanner}>
          <img
            src={itemEvent?.bannerURL}
            alt=""
            style={{
              maxWidth: "100%",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          />
        </Box>
      )}
      {!userInfo?.nationalId && (
        <Box className="parent-authentication">
          <Grid2
            container
            columns={12}
            className="authentication-box"
            onClick={handleAuthentication}
          >
            <Grid2 item size={{ xs: 2 }} className="icon-box">
              <Lottie animationData={InfoGif} loop autoplay className="icon" />
            </Grid2>
            <Grid2 item size={{ xs: 10 }} className="text-box">
              احراز هویت شما انجام نشده است!
              <span>احراز هویت</span>
            </Grid2>
          </Grid2>
        </Box>
      )}

      <Box className="menu-box">
        <MenuSection
          items={userMenuItems}
          className="person-menu"
          onItemClick={handleMenuItemClick}
        />

      </Box>
      {!isMobile && (
        <Box className="footer-box">
          <img src={FooterLogo} alt="On Academy" />
        </Box>
      )}

      <CustomModalLogOut
        open={openModalLogout}
        handleClose={setOpenModalLogout}
      />
      <PaymentModal
        open={openPrice}
        handleClose={()=> setOpenPrice(false)}
        textBody="کسی برای شرکت در این کنسرت پولی پرداخت نخواهد کرد.@@ بلیط‌ها صرفاً به ثبت‌نام‌کنندگان در «آکادمی آن» اختصاص می‌یابد و هیچ فرد یا مجموعه‌ای مجاز به فروش آن‌ها نیست. در صورت مشاهده دریافت هزینه برای عضویت در «آکادمی آن» و یا شرکت در این کنسرت، ضمن عدم پرداخت هرگونه وجه، لطفا به پشتیبانی اطلاع دهید."
        textTitle="نکته مهم درباره هزینه شرکت در کنسرت"
        textConfirmButton="ادامه"
        textCancleButton="بازگشت"
        functionConfirm={pricePopupCloseHandler}
      />
      {/* <RegistrationFinishedModal
        open={openPrice}
        handleClose={() => setOpenPrice(false)}
        textBody="با توجه به اتمام فرصت ثبت نام در کنسرت، امکان ثبت نام وجود ندارد.@@بزودی امکان انتخاب صندلی برای ثبت نام کنندگان به ترتیب اولویت امتیاز فراهم خواهد شد. تا روز چهارشنبه فرصت دارید با دعوت از دوستان خود به «آکادمی آن» و کسب امتیاز، اولویت بالاتری در انتخاب صندلی داشته باشید."
        textTitle="اتمام فرصت ثبت نام اولیه در کنسرت"
        textCancleButton="بازگشت"
      /> */}
    </Box>
  );
};

export default RightSidebar;
